export const isIphone = () => {
  if (!navigator?.userAgent) {
    return false;
  }

  return /iP(?:hone|od)/.test(navigator.userAgent);
};
